export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyC8pTnRwIagrUMOE9CIvFvAv70U3JfRtoc',
    authDomain: 'fieldai-58745.firebaseapp.com',
    projectId: 'fieldai-58745',
    storageBucket: 'fieldai-58745.firebasestorage.app',
    messagingSenderId: '15309924444',
    appId: '1:15309924444:web:046b31d905d484386dde99',
  },
  useEmulators: false,
};
